import React, { useState } from 'react';
import CopySuccessIcon from 'view/components/icons/CopySuccess';
import { copyToClipboard } from 'tools';
import CopyIcon from 'view/components/icons/Copy';
import IconButton, { IconButtonOwnProps } from '@mui/material/IconButton';
import Box from '@mui/material/Box';

type CopyButtonProps = {
  value: string;
  disabled?: boolean;
  edge?: IconButtonOwnProps['edge'];
};

export default function CopyButton({ value, disabled, edge }: CopyButtonProps) {
  const [isCopied, setIsCopied] = useState(false);

  const onCopyClick = () => {
    setIsCopied(true);
    copyToClipboard(value);

    setTimeout(() => setIsCopied(false), 3000);
  };

  return (
    <Box>
      <IconButton
        edge={edge}
        size="large"
        color="primary"
        disabled={disabled}
        onClick={onCopyClick}
      >
        {isCopied ? <CopySuccessIcon /> : <CopyIcon />}
      </IconButton>
    </Box>
  );
}
